import { Box, Grid } from '@material-ui/core'
import { contentWrapper } from './layout.style'
import React from 'react'

export const ResponsiveBox = ({ xs, sm, md, lg, xl, ...props }) => (
	<Grid container justify="center">
		<Grid item xs={xs} sm={sm} md={md} lg={lg} xl={xl} css={contentWrapper}>
			<Box {...props} />
		</Grid>
	</Grid>
)

ResponsiveBox.defaultProps = {
	xs: 12,
	md: 11,
}
